import { useState, useCallback } from "react";

export function useToast() {
  const [toast, setToast] = useState({ show: false, variant: "success", message: "" });

  const showToast = useCallback((variant, message) => {
    setToast({ show: true, variant, message });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, show: false }));
  }, []);

  return { toast, showToast, hideToast };
}
